import React, { PureComponent } from 'react';
import { Avatar } from '@/components/ui/Avatar';
import { User } from 'lucide-react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { arrayOf, shape, func, bool, string, number } from 'prop-types';

export default class ListOfUsers extends PureComponent<any> {
  static propTypes = {
    users: arrayOf(
      shape({
        degree_before: string,
        email: string,
        id: string,
        image_url: string,
        status: number,
        title_f: string,
      })
    ),
    fetchMoreData: func,
    hasMore: bool,
    onInvite: func,
  };

  static defaultProps = {
    users: [],
    fetchMoreData: () => {},
    hasMore: true,
    onInvite: () => {},
  };

  render() {
    const { users, fetchMoreData, hasMore, onInvite } = this.props;
    return (
      <InfiniteScroll
        dataLength={users.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        height={400}
      >
        <div>
          {users.map((item, i) => (
            <UserItem key={i} props={item} onInvite={onInvite} />
          ))}
        </div>
      </InfiniteScroll>
    );
  }
}

const UserItem = ({
  props: { email, degree_before, title_f, image_url, id, status, degree_after },
  onInvite,
}) => {
  return (
    <div className="group flex flex-row justify-between items-center border-b border-solid border-(--ink-50) hover:bg-(--ink-50)">
      <span className="flex justify-start items-center pl-[10px]">
        <Avatar
          size={40}
          style={{ marginRight: '10px' }}
          {...(image_url
            ? {
                src: image_url,
              }
            : {
                icon: <User className="h-4 w-4" />,
              })}
        />
        <span className="text-(--ink-600) text-xs mr-[15px] flex-[1_1] min-w-[250px] break-all">{`${degree_before} ${title_f} ${degree_after}`}</span>
        <span className="text-(--ink-600) text-xs mr-[15px] flex-[1_1] min-w-[250px] break-all">
          {email}{' '}
        </span>
      </span>
      {status === 1 && (
        <button
          className="text-(--ink-600) border-none h-[50px] min-w-[130px] bg-inherit font-medium group-hover:bg-(--brand-500) group-hover:text-primary-700 group-hover:cursor-pointer"
          data-testid={`users-invite-btn-${id}`}
          onClick={() => onInvite(id)}
        >
          {'Pozvat'}
        </button>
      )}
      {status === 0 && (
        <button className="text-(--ink-300) border-none h-[50px] min-w-[130px] bg-inherit font-medium group-hover:bg-inherit group-hover:cursor-not-allowed">
          {'Již zde pracuje'}
        </button>
      )}
      {status === 3 && (
        <button
          onClick={() => onInvite(id)}
          className="text-(--ink-600) border-none h-[50px] min-w-[130px] bg-inherit font-medium group-hover:bg-(--brand-500) group-hover:text-primary-700 group-hover:cursor-pointer"
          data-testid={`users-reinvite-btn-${id}`}
        >
          {'Odeslat znovu'}
        </button>
      )}
    </div>
  );
};
